<template>
  <div id="app">
    <template v-if="authorized && !shouldHideHeader && ['Search', 'AI_Home', 'ai_assistantIntro'].includes($route.name)">
      <SteelKnight />
      <SteelKnight side="left" />
      <SteelKnight variant="warlord" />
      <SteelKnight side="left" variant="lancer" />
      <KnightTreasure />
    </template>
    <loading :active.sync="isLoading"></loading>
    <Navbar ref="Navbar" v-if="authorized && !shouldHideHeader" />
    <router-view ref="Body" :key="!forceRemountRoutes.includes($route.name) ? $route.fullPath : null" :class="{ 'main-info':authorized && !shouldHideHeader
    }"/>
    <Footer v-if="$route.name !== 'Login' && !shouldHideHeader" />
    <Announcement v-if="authorized && !isHide && !shouldHideHeader"/>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import Announcement from '@/components/Announcement.vue'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import RadarChart from './components/RadarChart.vue'
import SteelKnight from './components/SteelKnight.vue'
import KnightTreasure from './components/KnightTreasure.vue'

export default {
  name: 'App',
  data () {
    return {
      forceRemountRoutes: [
        'ai_assistantIntro',
        'ai_assistantMain',
        'ai_assistant_correction',
        'ai_assistant_follow',
        'viewGenerate',
        'ChatAI',
        'chat_history',
        'viewChat',
        'conversation_rating',
        'records',
        'TOEIC_exam'
      ]
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'authorized'
    ]),
    shouldHideHeader() {
      return this.$route.matched.some(r => r.meta.hideHeader)
    },
    isHide () {
      let arr = ['CourseLesson', 'ChatAI', 'ai_assistantIntro', 'chat_history', 'conversation_rating', 'records', 'TOEIC_exam', 'ai_assistant_correction', 'ai_assistant_follow', 'ai_assistantMain']

      if (arr.indexOf(this.$route.name) > -1) {
        return true
      }
      // return this.$route.name === 'CourseLesson'
    }
  },
  components: {
    SteelKnight,
    KnightTreasure,
    Navbar,
    Loading,
    RadarChart,
    Announcement,
    Footer
}
}
</script>

<style lang="scss">
* {
  font-family: Avenir, Helvetica, Arial, sans-serif, 微軟正黑體, VideoJS !important;
  box-sizing: border-box;
}
#app {
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.main-info {
  margin: 93px 0 0 0;
  min-height: calc(100vh - 93px);
}
.btn-general {
  border-radius: 20px !important;
  width: 150px;
}
input:focus {
  outline: none;
}

.success {
  font-size: 1.5rem;
  margin-top: 60px;
}
.error {
  text-align: left;
  color: red;
  font-size: .8rem;
}
::placeholder {
  color: rgb(165, 165, 165);
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: rgb(165, 165, 165);
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: rgb(165, 165, 165);
}
</style>
